import { createGlobalStyle } from 'styled-components';
import { getSafeAreaValue } from '../../styled/theme/helpers/getSafeAreaValue';

export const BottomViewGlobalStyle = createGlobalStyle`
  .bottom-view {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-bottom: ${({ theme }) => getSafeAreaValue(theme, 'bottom', 0)};

    &__content {
      padding: 0 15px;
    }

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      border-bottom: 1px solid #eae5e1;
      position: relative;

      &-title {
        color: #2f1f19;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin: 0 auto;
        padding: 0 40px;
      }
    }

    &__close-btn {
      position: absolute;
      right: 0;
      margin: 0 15px;
    }
  }
`;
